export const NullProvider = () => {
  return null;
};
